module.exports = __webpack_public_path__ + "img/ticket-004.aff27a6b.svg";